import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { FirebaseAuthService } from 'src/app/Services/firebase-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
declare var $: any;


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  public loading: boolean = false;
  public submitted: boolean = false;
  selectedFile: any;
  public userId: any = '';
  public viewshow: boolean = true;
  public viewshow1: boolean = false;
  public termCheck: boolean = false;
  public typeCheck: boolean = false;
  public userTypeList: any = [];
  public termData: any = window.location.origin + '/terms-conditions';
  public privacyData: any = window.location.origin + '/privacy-policy';
  public usertYpes: any = 3;
  public currentUrl: any = this.router.url;
  public refCode: any = '';
  public Email: any = '';
  public usedEmail: boolean = false;
  public usedName: boolean = false;
  public isFirebaseSignup: boolean = false;
  public firebaseIdToken: string = '';
  public firebaseEnabled: boolean = false;
  public socialProvider: string = 'Google';
  public socialEmail: string = '';

  SignupData = new FormGroup({
    firstname: new FormControl('', Validators.compose([
      Validators.required ])),
    handlename: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(2),])),
    lastname: new FormControl('', Validators.compose([
      Validators.required ])),    
    email: new FormControl('', Validators.compose([
      Validators.required, Validators.email  ])),
    password: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')])),
    confirm_password: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')])),
    refCode: new FormControl(''),
    userType: new FormControl('', Validators.compose([
      Validators.required ])),         
  });
  
  get f() { return this.SignupData.controls; } 
  
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private service: GlobalService,
    private firebaseAuth: FirebaseAuthService
  ) { 
    this.getRoles();
  }

  ngOnInit(): void {
    this.firebaseEnabled = this.firebaseAuth.isEnabled;
    const navState = history.state;
    if (navState && navState.firebaseUser) {
      this.isFirebaseSignup = true;
      this.firebaseIdToken = navState.firebaseUser.idToken;
      this.socialProvider = navState.firebaseUser.provider || (navState.firebaseUser.email?.endsWith('privaterelay.appleid.com') ? 'Apple' : 'Google');
      const fName = navState.firebaseUser.name?.split(' ')[0] || '';
      const lName = navState.firebaseUser.name?.split(' ').slice(1).join(' ') || '';
      const email = navState.firebaseUser.email || '';
      this.Email = email;
      this.socialEmail = email;
      this.usedEmail = false;
      this.usedName = false;
      this.SignupData.patchValue({
        email: email,
        handlename: email,
        firstname: fName,
        lastname: lName
      });
      this.SignupData.get('password')?.clearValidators();
      this.SignupData.get('password')?.updateValueAndValidity();
      this.SignupData.get('confirm_password')?.clearValidators();
      this.SignupData.get('confirm_password')?.updateValueAndValidity();
    }

    this.route.queryParams.subscribe((params: any) => {
      const code = params['ref'] || params['referral_code'] || params['code'] || params['referralCode'];
      if (code) {
        this.refCode = code;
        this.SignupData.patchValue({ refCode: code });
      }
      if (params['email'] && !this.SignupData.value.email && !this.isFirebaseSignup) {
        this.Email = params['email'];
        this.SignupData.patchValue({ email: params['email'], handlename: params['email'] });
      }
    });

    if (!this.refCode && window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('ref') || urlParams.get('referral_code') || urlParams.get('code');
      if (code) {
        this.refCode = code;
        this.SignupData.patchValue({ refCode: code });
      }
      const emailParam = urlParams.get('email');
      if (emailParam && !this.SignupData.value.email && !this.isFirebaseSignup) {
        this.Email = emailParam;
        this.SignupData.patchValue({ email: emailParam, handlename: emailParam });
      }
    }
  }

  async signupWithGoogle() {
    try {
      this.loading = true;
      const { idToken, user } = await this.firebaseAuth.signInWithGoogle();
      this.handleSocialSignup(idToken, user, 'Google');
    } catch (err: any) {
      this.loading = false;
      if (err?.code !== 'auth/popup-closed-by-user') {
        this.service.dangerAlert(err?.message || 'Google sign-up failed');
      }
    }
  }

  async signupWithApple() {
    try {
      this.loading = true;
      const { idToken, user } = await this.firebaseAuth.signInWithApple();
      this.handleSocialSignup(idToken, user, 'Apple');
    } catch (err: any) {
      this.loading = false;
      if (err?.code !== 'auth/popup-closed-by-user') {
        this.service.dangerAlert(err?.message || 'Apple sign-up failed');
      }
    }
  }

  private handleSocialSignup(idToken: string, user: any, provider: string = 'Google') {
    this.service.PostApis({ idToken }, '/firebase-login').subscribe({
      next: (response: any) => {
        if (response.success == 1 && response.data && !response.data.isNewUser) {
          // Already an existing user! Log in directly
          localStorage.setItem('grw_login', JSON.stringify(response.data || {}));
          localStorage.setItem('grw_token', response.data.token);
          this.router.navigate(['/dashboard']);
          return;
        }
        // Account does not exist yet -> populate signup form to complete registration
        this.populateSocialSignup(idToken, user, provider, response?.data);
      },
      error: () => {
        // Account does not exist -> proceed with signup form population
        this.populateSocialSignup(idToken, user, provider);
      }
    });
  }

  private populateSocialSignup(idToken: string, user: any, provider: string = 'Google', responseData?: any) {
    this.loading = false;
    this.isFirebaseSignup = true;
    this.firebaseIdToken = idToken;
    this.socialProvider = provider || (user?.providerData?.[0]?.providerId === 'apple.com' ? 'Apple' : 'Google');
    const nameParts = (user?.displayName || responseData?.name || '').split(' ');
    const email = user?.email || responseData?.email || '';
    this.Email = email;
    this.socialEmail = email;
    this.usedEmail = false;
    this.usedName = false;
    this.SignupData.patchValue({
      email: email,
      handlename: email,
      firstname: nameParts[0] || '',
      lastname: nameParts.slice(1).join(' ') || ''
    });
    this.SignupData.get('password')?.clearValidators();
    this.SignupData.get('password')?.updateValueAndValidity();
    this.SignupData.get('confirm_password')?.clearValidators();
    this.SignupData.get('confirm_password')?.updateValueAndValidity();
  }

  unlinkSocialAccount() {
    this.isFirebaseSignup = false;
    this.firebaseIdToken = '';
    this.socialProvider = '';
    this.socialEmail = '';
    this.Email = '';
    this.SignupData.patchValue({
      email: '',
      handlename: '',
      password: '',
      confirm_password: ''
    });
    this.SignupData.get('password')?.setValidators(Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')]));
    this.SignupData.get('password')?.updateValueAndValidity();
    this.SignupData.get('confirm_password')?.setValidators(Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30),
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')]));
    this.SignupData.get('confirm_password')?.updateValueAndValidity();
  }

  Onsubmit() {
    this.submitted = true;  
    let userdetail = this.SignupData; 
    if (this.usertYpes == 2) {
      if (this.typeCheck == false) {
        this.service.dangerAlert('Please accept the authorisation');
        return;
      }
    } 
    if (this.termCheck == false) {
      this.service.dangerAlert('Please accept the Terms and Conditions');
      return;
    }

    if (this.isFirebaseSignup) {
      if (this.socialEmail) {
        this.Email = this.socialEmail;
        this.SignupData.patchValue({
          email: this.socialEmail,
          handlename: this.socialEmail
        });
      }
      if (userdetail.valid) {
        this.loading = true;
        var ssVal: any = this.typeCheck ? 1 : 0;
        var fUrl = "/firebase-signup";
        const lockedId = (this.socialEmail || userdetail.value.email || userdetail.value.handlename || '').toLowerCase();
        var fDetail = {
          "idToken": this.firebaseIdToken,
          "firstName": userdetail.value.firstname,
          "lastName": userdetail.value.lastname,
          "role": userdetail.value.userType,
          "referral_code": userdetail.value.refCode || "",
          "userHandler": lockedId,
          "authorized_person": ssVal
        };
        this.service.PostApis(fDetail, fUrl).subscribe({
          next: (response: any) => {
            if (response.success == 1) {
              localStorage.setItem('grw_login', JSON.stringify(response.data || {}));
              localStorage.setItem('grw_token', response.data.token);
              this.router.navigate(['/dashboard']);
            } else {
              this.loading = false;
              this.service.dangerAlert(response.message);
            }
          },
          error: (err: any) => {
            this.loading = false;
            this.service.dangerAlert(err?.message || 'Firebase sign-up failed');
          }
        });
      }
      return;
    }

    if (userdetail.value.confirm_password != userdetail.value.password) {
      this.service.dangerAlert('Password not match');        
      return;
    }

    if (userdetail.valid) {
      this.loading = true; 
      var ss: any = 0;
      if (this.typeCheck == true) {
        ss = 1;
      }
      var url = "/sign-up";
      var detail = {
        "firstName": userdetail.value.firstname,
        "lastName": userdetail.value.lastname, 
        "email": (userdetail.value.email)?.toLowerCase(),
        "password": userdetail.value.password,
        "role": userdetail.value.userType,
        "referral_code": userdetail.value.refCode || "",
        "userHandler": (userdetail.value.handlename)?.toLowerCase(),
        "authorized_person": ss
      };
      this.service.PostApis(detail, url).subscribe({
        next: (response: any) => {
          if (response.success == 1) { 
            this.viewshow = false;
            this.viewshow1 = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.service.dangerAlert(response.message);
          }
        },
        error: (error: any) => {
          this.loading = false;
        }
      });
    }
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa fa-eye-slash");
      $(str).addClass("far fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("far fa-eye ");
      $(str).addClass("fa fa-eye-slash");
    }
  }

  checkEmailUnique(event: any) { 
    if (this.isFirebaseSignup) {
      if (this.socialEmail) {
        this.Email = this.socialEmail;
        this.SignupData.patchValue({ email: this.socialEmail, handlename: this.socialEmail });
      }
      return;
    }
    this.loading=true;
    const email = event.target.value;
    if (email.length > 0) {
      this.service.PostApis({ email: email }, "/check-unique-email").subscribe(
        (response: any) => {
          if (response.success !=1) {
            // event.target.value = "";
            this.usedEmail=true;
            this.service.dangerAlert(response.message);  
          } else{
            this.usedEmail= false;
          }
          this.loading=false;
        },
        (error) => {
        }
      );
      this.loading=false;
    } else{
      this.usedEmail= false;
      this.loading=false;

    }
  }

  checkhandlerUnique(event: any) {
    if (this.isFirebaseSignup) {
      if (this.socialEmail) {
        this.SignupData.patchValue({ handlename: this.socialEmail, email: this.socialEmail });
      }
      return;
    }
    this.loading=true;
    const email = event.target.value;
    if (email.length > 0) {
      this.service.PostApis({ userHandler: email }, "/check-unique-user-handle").subscribe(
        (response: any) => {
          if (response.success !=1) {
            // event.target.value = "";  
            this.usedName=true;
            this.service.dangerAlert(response.message);        
          } else {
            this.usedName=false;
          }
          this.loading=false;
        },
        (error) => {
          this.loading=false;
        }
      );
      this.loading=false;
    } else{
      this.usedName=false;
      this.loading=false;
    }
  }

  getCheckType(event:any,type:any){
    if(type == 1){
      this.typeCheck = event.target.checked;
    } else {
      this.termCheck = event.target.checked;
    }
    
  }

  getRoles(){
    const url = "/get-roles"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        response.data.filter((el:any)=>{
          if(el.role_id==3){
            self.SignupData.controls['userType'].setValue(el._id);
          }         
        })
        this.userTypeList = response.data;
        if (this.currentUrl.includes('?')) {
          var s: any = this.currentUrl.split('?');
          this.currentUrl = s[0];
          try {
            var urlSearch = new URLSearchParams(s[1]);
            var ref = urlSearch.get('ref') || urlSearch.get('referral_code') || urlSearch.get('code');
            if (ref) {
              this.usertYpes = 3;
              this.refCode = ref;
              this.SignupData.patchValue({ refCode: ref });
            }
            var emailParam = urlSearch.get('email');
            if (emailParam && !this.SignupData.value.email && !this.isFirebaseSignup) {
              this.Email = emailParam;
              this.SignupData.patchValue({ email: emailParam, handlename: emailParam });
            }
          } catch (e) {}
        }
      }
    }), (error) => { this.loading =false; });
  }

  getstatic(){
    this.service.GetApi("/privacy-policy").subscribe(((response:any)=>{
      if(response.success ==1) {
        this.privacyData = response.data;
      }
    }), (error) => { this.loading =false; });

    this.service.GetApi("/term-conditions").subscribe(((response:any)=>{
      if(response.success ==1) {
        this.termData = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  setCheckval(event:any){
    var self =this;
    this.userTypeList.filter((el:any)=>{
      if(el._id == event.value){
        self.usertYpes= el.role_id;
      }
    });
  }

}
